<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>
        <a class="back" (click)="backClicked()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> {{'Device Transfer' | translate}}
      </h1>
      <button pButton type="button" label="{{'Save' | translate}}" icon="pi pi-save" class="{{Confirm_button}}" (click)="comfirmTransfer()"
        [disabled]="targetList.length === 0 || targetList_company.value == undefined || (sourceList_company.value == targetList_company.value)"></button>
    </div>
    <div class="page-content transfer">
      <div class="transferFilter">
        <div class="sourceFilter">
          <p-select [options]="sourceCompanyOptions" [(ngModel)]="filterParam.RegionId" (onChange)="filterChange()" placeholder="Select Source Company"></p-select>
        </div>
        <div class="sourceMiddle"></div>
        <div class="targetFilter">
          <!-- <p-select [options]="targetCompanyOptions" [(ngModel)]="filterTargetParam.RegionId" (onChange)="selectTargetCompany()" placeholder="Select Transfer Company"
            [disabled]="targetDropdownDisabled"></p-select> -->
          <p-select [options]="targetCompanyOptions" [(ngModel)]="filterTargetParam.RegionId" (onChange)="selectTargetCompany()" placeholder="Select Transfer Company"></p-select>
        </div>
      </div>
      <div class="transferContent">
        <p-pickList #pickList [source]="sourceList" [target]="targetList" sourceHeader="Transfer from {{sourceList_company.label}} ({{sourceList.length}})"
        targetHeader="Transfer to {{targetList_company.label}} ({{targetList.length}})"
          dragdrop="true" filterBy="DeviceName" sourceFilterPlaceholder="Search" targetFilterPlaceholder="Search" [sourceStyle]="{'height':'450px'}"
          [targetStyle]="{'height':'450px'}" [showSourceControls]="false" [showTargetControls]="false" [showSourceFilter]="true" [showTargetFilter]="true">
          <ng-template let-item pTemplate="item">
            <div class="data">
              <h5 style="margin: 0;">{{item.DeviceName}}</h5>
              <p>{{item.deviceModel}}</p>
            </div>
          </ng-template>
        </p-pickList>
      </div>
    </div>
  </div>
</div>
<p-toast [style]="{marginTop: '70px'}"></p-toast>


<!-- Transfer Device Confirm -->
<p-dialog header="Confirm" [(visible)]="transferDeviceConfirmDialog" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p>Are you sure you want to proceed with the device transfer?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="Confirm" class="{{Confirm_button}}" (click)="saveTransfer()"></button>
      <button type="button" pButton (click)="transferDeviceConfirmDialog=false" label="Cancel" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>
